<div class="infobulle" (mouseover)="displayContent = true" (mouseout)="displayContent = false">
    <span [class]="icon ? 'icon ' + icon : 'icon i-info'"></span>
    <div *ngIf="displayContent" class="content">
        <h3 *ngIf="text">{{ text | translate }}</h3>
        <ng-content></ng-content>
    </div>
</div>
